import React, { Fragment, useEffect, useRef, useState } from 'react'
import AddComponent from '../../../components/AddComponent'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid'
import LinkButton from '../../helpers/LinkButton'
import Table from '../../helpers/Table'
import Loader from '../../Common/Loader'
import { Link } from 'react-router-dom'
import ActionButton from '../../helpers/ActionButton'
import { useReactToPrint } from 'react-to-print'
import Pagination from '../../helpers/Pagination';
import { AddCircle } from 'iconsax-react'
import { DeleteGladianceUser, GetGladianceUserList } from '../../../Encapsulation/GladianceDomainEntities/GladianceUser'
import flasher from '@flasher/flasher'
import Swal from 'sweetalert2'
  
    function GladianceUserRoleMaster() {
     
        function classNames(...classes) {
            return classes.filter(Boolean).join(' ')
        }
                document.title = 'Gladiance - Users'
            const tableHeading = ['Sr.No', 'Department','job Title', 'User Role','User Name','Action']
            const [loader, setLoader] = useState(false)
      
            const [currentPage, setCurrentPage] = useState(1);
            const itemsPerPage = 7;
            const [errors, setErrors] = useState([])
            const [gladianceUserList, setGladianceUserList] = useState([]);


            const fetchGladianceUserList = async () => {
                setGladianceUserList(await GetGladianceUserList(setErrors));
            }

            const handlePageChange = (pageNumber) => {
                setCurrentPage(pageNumber);
            };
        
            const componentRef = useRef();
            const handlePrint = useReactToPrint({
                content: () => componentRef.current,
            });
        
            const handleGladianceUserMasterCsv = () => {
                // setLoader(true)
                // const formData = new FormData()
                // formData.append('GladianceDepartmentMasterCsv', GladianceDepartmentMasterCsv)
                // axiosClient.post(`import_material`, formData)
                //     .then(({ data }) => {
                //         flasher.success(data.msg)
                //         setLoader(false)
                //     })
                //     .catch(({ response }) => {
                //         setLoader(false)
                //     })
                // setViewModel(false)
                // getGladianceUserList()
            }
        
            const deleteUser = (tableData) => {
                Swal.fire({
                    title: 'Are you sure to delete this?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        let response = await DeleteGladianceUser(tableData)
                        if (response.Successful == false) {
                            flasher.warning(response.Message)
                        } else {
                            flasher.success('Deleted Successfully')
                            fetchGladianceUserList();
                        }
                    }
                })
            }

            useEffect(() => {
                fetchGladianceUserList();
            }, [])
        
            return (
                <Fragment>
                    {loader ? (<Loader />) : (
                        <AddComponent title={'Users'} button={
                            <LinkButton to={'/gladiance-user-master/add-user-master'}>
                                <AddCircle variant='Bold' className='w-5 h-5' />
                                <span>Add User</span>
                            </LinkButton>
                        }>
                            {gladianceUserList && gladianceUserList.length > 0 ? (
                                <div ref={componentRef} className='m-2'>
                                    <Table tableHeading={tableHeading}>
                                        {gladianceUserList && gladianceUserList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((tableData, tableDataID) => {
                                            return (
                                                <Fragment key={tableDataID}>
                                                     <tr className="border-b border-opacity-30 border-white">
                                                        <td className="px-4 py-3">{tableDataID + 1}</td>
                                                        <td className="px-4 py-3">{tableData.GladianceDepartmentName}</td>
                                                        <td className="px-4 py-3">{tableData.GladianceJobTitleName}</td>
                                                        <td className="px-4 py-3">{tableData.GladianceUserRoleName}</td>
                                                        <td className="px-4 py-3">{tableData.Name}</td>
                                                        <td className="px-4 py-3">
                                                            <div className='flex justify-center gap-3'>
                                                                <Link to={`/gladiance-user-master/edit-gladiance-user-master/${tableData.Ref}`} title='Edit' ><ActionButton className={'p-1.5 text-white bg-yellow-400 '}>
                                                                    <PencilSquareIcon className='w-4 h-4' />
                                                                </ActionButton></Link>
                                                                <ActionButton onClick={() => deleteUser(tableData)} title={'Delete'} className='p-1.5 text-white bg-red-600 rounded-lg cursor-pointer'>
                                                                    <TrashIcon className='w-4 h-4' />
                                                                </ActionButton>
                                                                
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </Fragment>
                                            )
                                        })}
                                    </Table>
                                </div>
        
                            ) : (
                                <div className='flex justify-center items-center h-[20vh] md:h-[70vh]'>
                                    <p className='text-[3vw] md:text-3xl font-bold'>Sorry! User Master Data Not Found</p>
                                </div>
                            )}
                            {gladianceUserList && gladianceUserList.length > 7 ? (<div className="flex justify-end">
                                <Pagination
                                    itemsPerPage={itemsPerPage}
                                    totalItems={gladianceUserList.length}
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                />
                            </div>) : (<div></div>)
                            }
        
                        </AddComponent>
                    )}
                </Fragment>
            )
        }    

export default GladianceUserRoleMaster
